import clsx from "clsx";
import React from "react";
import classes from "./styles.module.scss";

import RankBadge from "../RankBadge";
import { PlayerAvatar } from "../PlayerAvatar";

function RankCard({
  user,
  userDark,
  player = {
    rank: 1,
    username: "HolyPond#799523",
    score: 1000,
  },
}) {
  const { rank, value: score } = player;

  return (
    <div
      className={clsx(
        " flex  items-center gap-2 rounded-md bg-primary-content/10 p-2 pl-3 shadow-sm backdrop-blur-sm md:gap-4 md:pl-5",
        rank === 1 && classes.goldTab,
        rank === 2 && classes.silverTab,
        rank === 3 && classes.bronzeTab
      )}
    >
      <span className="text-md">
        <RankBadge rank={rank} />
      </span>
      <div className="hidden md:block">
        <PlayerAvatar size={30} username={player.username} />
      </div>
      <p className="text-md flex-1 overflow-hidden text-ellipsis whitespace-nowrap text-start font-semibold sm:max-w-[165px]">
        {user ? `${player.username + "(You)"}` : player.username}
      </p>
      <span
        className={`ml-auto min-w-[100px] rounded-md bg-tertiary-base px-2 py-3 text-center drop-shadow-sm ${
          user ? "text-lg" : "text-md"
        } `}
      >
        {score}
      </span>
    </div>
  );
}

export default RankCard;
